angular.module('autoremind.templates')
    .directive('usersListForTemplate', ['templateService', '$interval', 'dialogs', '$timeout',
    function (templateService, $interval, dialogs, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/templates/users-list-for-template.html',
            link: function (scope, elem, attr) {
                scope.viewModel = {
                    templateId: scope.templateId,
                    templateFileRef: scope.templateFileRef,
                    usersList: [],
                    usersListWithTemplateRef: [],
                    loadingIndicator: {
                        refCount: 0,
                        state: false
                    }
                };
                scope.getUsersForCurrentTemplate = function () {
                    templateService.getUsersListByTemplateId(scope.viewModel.templateFileRef, scope.viewModel.templateId, scope.viewModel.loadingIndicator)
                        .then(function (result) {
                        scope.viewModel.usersList = result.assignedUsersForTemplate;
                        scope.viewModel.usersListWithTemplateRef = result.assignedUsersForTemplateRef;
                    }, function (error) {
                        console.log('getUsersListByTemplateId error: ', error);
                    });
                };
                scope.getUsersForCurrentTemplate();
                scope.selectUser = function (user) {
                    scope.success(user);
                };
            }
        };
    }]);
//# sourceMappingURL=users-list-for-template.directive.js.map